import React from "react";
import { Checkbox, FormControlLabel, InputLabel, Stack } from "@mui/material";
import { Divider } from "@aws-amplify/ui-react";
import { ModalSpinner } from "components/ModalSpinner";

export const SenderSelector = ({
  specialists,
  role,
  handleChangeSpecialist,
  isLoading,
  noHeader = false,
  onlyOne = false,
  sx = {},
}) => {
  const isSpecialistsNotEmpty = Object.keys(specialists).length;

  if (isLoading)
    return (
      <>
        <Divider />
        <div>Loading...</div>
        <Divider />
        <ModalSpinner open />
      </>
    );

  if (!isSpecialistsNotEmpty)
    return (
      <>
        <Divider />
        <div>No senders in this practice</div>
        <Divider />
      </>
    );

  return (
    <Stack sx={sx}>
      {!noHeader && (
        <>
          <InputLabel sx={{ textAlign: "left" }}>{role}s</InputLabel>
          <Divider />
        </>
      )}
      {Object.keys(specialists).map((id) => {
        const { selected, label } = specialists[id];
        return (
          <FormControlLabel
            key={id}
            control={
              <Checkbox
                checked={selected}
                onChange={(e) =>
                  handleChangeSpecialist(e, role, id, label, onlyOne)
                }
                name={id}
              />
            }
            label={label}
            sx={{
              userSelect: "none",
              textAlign: "left",
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem",
                color: "#000000",
              },
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
              padding: "0",
            }}
          />
        );
      })}
    </Stack>
  );
};
